<template>
    <span class="contentMenuTitle">{{ text }}</span>
</template>

<script>
export default {
    props: ['text'],
    data() {
        return {}
    },
    methods: {

    }
}

</script>

<style scoped>
.contentMenuTitle {
    text-align: center;
    font-weight: 500;
    font-size: 28px;
    color: #222222;
    margin-bottom: 30px;
    text-align: center;
    display: inline-block;
    width: 100%;
}


@media screen and (max-width: 900px) {
    .contentMenuTitle {
        font-size: 18px;
        margin-bottom: 12px;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/contentMenuTitle.vue